// 订单中心->智能地址解析页面

import listeningToKeydownMixin from '@/assets/js/mixins/listeningToKeydown.js';

const areaList = require('@/assets/js/address/area-list.js');
const { parse, parseArea } = require('@/assets/js/address/address-parse.js');

parseArea(areaList);
const AI_LOOP_LOCAL_STORE_KEY = 'AI_LOOP_LOCAL_KEY';
let AI_LOOP_TIME_KEY = null;

// 开始事件比当前时间小于60s则开始循环
const openLoop = (localKey, { endCb, startCb }, loopTime = 1000) => {
  const COUNTDOWN = 59; // 倒计时时间
  const endTime = 1; // 结束最小时间
  AI_LOOP_TIME_KEY = 1;
  const _openLoop = () => {
    const localTimeInfoStr = localStorage.getItem(localKey);
    if (localTimeInfoStr && AI_LOOP_TIME_KEY) {
      const REMAINDER_TIME = COUNTDOWN - (new Date().getTime() - localTimeInfoStr) / 1000;
      if (REMAINDER_TIME > endTime) {
        startCb && startCb(REMAINDER_TIME);
        AI_LOOP_TIME_KEY = setTimeout(() => {
          _openLoop();
        }, loopTime);
      } else {
        localStorage.setItem(localKey, '');
        endCb && endCb(REMAINDER_TIME);
      }
    } else {
      endCb && endCb(0);
    }
  };
  _openLoop();
};

export default {
  /* props: {
    componentData: {},
  }, */
  mixins: [listeningToKeydownMixin],
  components: {},
  data() {
    return {
      needDecrypt: false, // 是否需要解密
      isDecrypt: false, // 是否已解密
      isDecryptLoading: false,
      decryptData: {}, // 解密数据
      changDisabled: false,
      aiAddr: '', // 智能识别地址
      openAiText: '智能识别',
      aiDisabled: false,
      componentData: {},
      isWatchChange: false, // 监听是否手动修改
      isShowFromLoading: false, // 加载
      objId: -1,
      newReceivAddress: '',
      ReceivAddress: '', // 新地址
      ReceivProvince: '', // 省市区
      ReceivCity: '',
      ReceivArea: '',
      ReceivTown: '',
      ReceivProvinceName: '',
      ReceivCityName: '',
      ReceivAreaName: '',
      ReceivTownName: '',
      ReceivName: '', // 收货人
      ReceivMobile: '', // 手机号
      provList: [],
      cityList: [],
      townList: [],
      areaList: [],
      parseAddressLoad: false,
      dataAysis: true, // 智能解析地址是否正确
      regx: {
        mobile: /^\d{11}$/,
        phone: /^\d{11,12}$/,
        shipamt: /^\d*(\.[0-9]{0,2})?$/,
        shipzip: /^\d{6}$/,
        number: '/^d?$/',
      },
      // 2019-8-12 去掉收货人的正则        name: /^[a-zA-Z_\u4e00-\u9fa5]+$/,
      data: {
        receiver_address: '',
        cp_c_region_province_id: '',
        cp_c_region_city_id: '',
        cp_c_region_area_id: '',
        cp_c_region_town_id: '',
        cp_c_region_town_ename: '',
        receiver_name: '',
        receiver_mobile: '',
        receiver_phone: '',
        receiver_zip: '',
        ship_amt: '',
        platform_province: '',
        platform_city: '',
        platform_area: '',
        platform_town: '',
        updateScope: '',
      }, // 需要提交的数据
      btnConfig: {
        typeAll: 'error', // 按钮统一风格样式
        btnsite: 'right', // 按钮位置 (right , center , left)
        buttons: [
          {
            text: t('取消'),
            btnclick: () => {
              this.$parent.$parent.closeConfirm();
            }, // 按钮点击事件
          },
          {
            text: t('确定'),
            btnclick: () => {
              this.update();
            },
          }
        ],
      },
    };
  },
  watch: {
    componentData: {
      handler(obj, oldval) {
        // 监测数据
        this.needDecrypt = Boolean(obj.DECRYPT_RULE)
        this.initAddress(obj);
      },
      deep: true,
      immediate: true
    },
  },
  computed: {
    isCN () {
      // 是否是中国
      return this.componentData.CP_C_REGION_COUNTRY_ID == 1
    }
  },
  beforeDestroy() {
    AI_LOOP_TIME_KEY = null;
  },
  methods: {
    /**
     * 订单收货地址-解密
     */
    handleDecrypt() {
      if (this.isDecrypt) {
        this.isDecrypt = false
        return
      }
      const self = this
      if (this.componentData.IS_SYS_ENCRYPTED == 1) {
        $fcWarn({
          className: 'ark-dialog',
          title: t('提示'),
          content: `${t('当前操作会影响该平台上的解密额度，请谨慎操作！是否继续执行解密？')}`,
          mask: true,
          showCancel: true,
          onOk: () => {
            self.handleDecryptExe()
          }
        });
      } else {
        self.handleDecryptExe()
      }
    },
    async handleDecryptExe() {
      this.isDecryptLoading = true
      const params = {
        IS_SYS_ENCRYPTED: this.componentData.IS_SYS_ENCRYPTED,
        orderId: this.componentData.ID,
        decryptRule: this.componentData.DECRYPT_RULE
      }
      const { data: { code, data } } = await this.service.orderCenter.orderDecrypt(params)
      this.isDecrypt = true
      this.isDecryptLoading = false
      if (code == 0) {
        this.data = Object.assign({}, this.data, {
          receiver_name: data.name,
          receiver_mobile: data.mobile,
          receiver_phone: data.phone,
          receiver_address: data.addressDetail
        })
      } else {
        this.isDecrypt = false
      }
    },
    openAiAdder() {
      if (this.aiDisabled) return;
      if (!this.aiAddr) {
        this.$Message.warning('请填写智能设别地址');
        return;
      }
      localStorage.setItem(AI_LOOP_LOCAL_STORE_KEY, new Date().getTime());

      openLoop(AI_LOOP_LOCAL_STORE_KEY, { startCb: this.aiDisabledStart, endCb: this.aiDisabledEnd });
      this.service.orderCenter.addressRecognize({ param: this.aiAddr }).then((res) => {
        if (res.data.code === 0) {
          this.$Message.success('识别完成');
          this.aiAddress(res.data.data);
        }
      });
    },
    // 解决重新赋值时，弹窗弹出的问题
    async fixSelectBug(type) {
      try {
        if (!type) {
          this.$refs.provinceSelect.handleDropHide();
          this.$refs.citySelect.handleDropHide();
          this.$refs.areaSelect.handleDropHide();
          await new Promise((resolve) => setTimeout(resolve, 1000));
        }
        const opacity = type ? 0 : null;

        this.$refs.provinceSelect.$refs.dropdown.$el.style.setProperty('opacity', opacity, 'important');
        this.$refs.citySelect.$refs.dropdown.$el.style.setProperty('opacity', opacity, 'important');
        this.$refs.areaSelect.$refs.dropdown.$el.style.setProperty('opacity', opacity, 'important');
        console.log(this.$refs.provinceSelect.$refs.dropdown.$el.style, style);
      } catch (error) {
        console.error(error);
      }
    },
    async aiAddress(obj) {
      this.fixSelectBug(true);
      this.data.cp_c_region_province_id = obj.CP_C_REGION_PROVINCE_ID;
      await this.getCity();
      this.data.cp_c_region_city_id = obj.CP_C_REGION_CITY_ID;
      this.data.cp_c_region_province_id = obj.CP_C_REGION_PROVINCE_ID; // 重新赋值，解决vue更新dom时，触发底层组件库清除绑定值得bug
      await this.getArea();
      this.data.cp_c_region_area_id = obj.CP_C_REGION_AREA_ID;
      this.data.cp_c_region_town_ename = obj.CP_C_REGION_TOWN_ENAME;
      this.data.receiver_address = obj.RECEIVER_ADDRESS || '';
      this.data.receiver_name = obj.RECEIVER_NAME || '';
      this.data.receiver_mobile = obj.RECEIVER_MOBILE || '';
      this.data.receiver_phone = obj.RECEIVER_PHONE || '';
      this.data.receiver_zip = obj.RECEIVER_ZIP || '';
      this.data.platform_province = obj.PLATFORM_PROVINCE || '';
      this.data.platform_city = obj.PLATFORM_CITY || '';
      this.data.platform_area = obj.PLATFORM_AREA || '';
      this.data.platform_town = obj.PLATFORM_TOWN || '';
      this.data.updateScope = 'CURRENT_ORDER';
      this.fixSelectBug(false);
    },
    aiDisabledEnd(REMAINDER_TIME) {
      this.openAiText = '智能识别';
      this.aiDisabled = false;
    },
    aiDisabledStart(REMAINDER_TIME) {
      this.aiDisabled = true;

      this.$nextTick().then(() => {
        this.openAiText = parseInt(REMAINDER_TIME) + 's';
      });
    },
    onOpenChange(type) {
      if (type === 'city') {
        this.getCity();
      } else if (type === 'area') {
        this.getArea();
      } else if (type === 'town') {
        this.getTown();
      }
    },
    initAddress(obj) {
      this.data.cp_c_region_province_id = obj.CP_C_REGION_PROVINCE_ID;
      this.getCity();
      this.data.cp_c_region_city_id = obj.CP_C_REGION_CITY_ID;
      this.getArea();
      this.data.cp_c_region_area_id = obj.CP_C_REGION_AREA_ID;
      this.getTown()
      this.data.cp_c_region_town_id = obj.CP_C_REGION_TOWN_ID;
      this.data.cp_c_region_town_ename = obj.CP_C_REGION_TOWN_ENAME;
      this.data.receiver_address = obj.RECEIVER_ADDRESS || '';
      this.data.receiver_name = obj.RECEIVER_NAME || '';
      this.data.receiver_mobile = obj.RECEIVER_MOBILE || '';
      this.data.receiver_phone = obj.RECEIVER_PHONE || '';
      this.data.receiver_zip = obj.RECEIVER_ZIP || '';
      this.data.platform_province = obj.PLATFORM_PROVINCE || ''
      this.data.platform_city = obj.PLATFORM_CITY || ''
      this.data.platform_area = obj.PLATFORM_AREA || ''
      this.data.platform_town = obj.PLATFORM_TOWN || ''
      this.data.updateScope = 1;
      if (obj.DECRYPT_RULE && obj.IS_SYS_ENCRYPTED != 3) {
        this.data.receiver_address = ''
        this.data.receiver_name = ''
        this.data.receiver_mobile = ''
        this.data.receiver_phone = ''
      }
    },
    async parseAddress() {
      if (this.newReceivAddress === '') return;
      this.parseAddressLoad = true;
      const result = parse(this.newReceivAddress);
      this.ReceivName = result.name;
      this.ReceivMobile = result.mobile;
      this.ReceivAddress = result.addr;
      this.ReceivTownName = result.town;
      this.ReceivAreaName = result.area;
      this.ReceivCityName = result.city;
      this.ReceivProvinceName = result.province;
      // 地址解析默认是正确状态
      this.dataAysis = true;
      // 判断省市区
      await this.intelligentAddress();
      // 判断是收货人基础信息是否正确
      await this.intelligentReciver();
      this.parseAddressLoad = true;
    },
    // 判断省市区是是否正确
    async intelligentAddress() {
      if (this.dataAysis) await this.searchProv();
      if (this.dataAysis) await this.searchCity();
      if (this.dataAysis) await this.searchArea();
    },
    async intelligentReciver() {
      if (!this.dataAysis) return;
      if (this.ReceivMobile) {
        const f = this.CheckRegx(this.regx.mobile, this.ReceivMobile);
        // if (!f) return this.CheckRegxMobile();  // 由于零售发货单手工修改手机或者电话号码，平台测会存在给的是虚拟号码，导致当前逻辑触发正则表达式验证不允许修改，故：手工修改电话或者手机号码时，去掉正则表达式验证。
      } else {
        return $fcError(t('请填写收货人手机'));
      }
      if (this.ReceivName) {
        // let f = this.CheckRegx(this.regx.name, this.ReceivName);
        // if (!f) return this.CheckRegxName();
      } else {
        return $fcError(t('请填写收货人名称'));
      }

      this.data.receiver_name = this.ReceivName;
      this.data.cp_c_region_province_id = this.ReceivProvince;
      this.data.receiver_mobile = this.ReceivMobile;
      this.data.cp_c_region_city_id = this.ReceivCity;
      this.data.cp_c_region_area_id = this.ReceivArea;
      this.data.cp_c_region_town_ename = this.ReceivTown;
      this.data.receiver_address = this.ReceivAddress;
    },
    update() {
      if (!this.data.cp_c_region_province_id) {
        return $fcError(t('请填写省份！'));
      }
      if (!this.data.cp_c_region_city_id) {
        return $fcError(t('请填写城市！'));
      }
      if (!this.data.receiver_address) {
        return $fcError(t('请填写详细地址！'));
      }
      //  f = this.CheckRegx(this.regx.name, this.data.receiver_name);
      // if (!f) return this.CheckRegxName();
      let f = this.CheckRegx(this.regx.mobile, this.data.receiver_mobile);
      if (this.componentData.ck != 50) {
        // 由于零售发货单手工修改手机或者电话号码，平台测会存在给的是虚拟号码，导致当前逻辑触发正则表达式验证不允许修改，故：手工修改电话或者手机号码时，去掉正则表达式验证。
        // if (!f && this.data.receiver_mobile !== this.componentData.RECEIVER_MOBILE) return this.CheckRegxMobile();
      }
      // f = this.CheckRegx(this.regx.phone, this.data.receiver_phone);
      // if (!f) return this.CheckRegxPhone();
      // 国家=中国才校验邮编
      if (this.data.receiver_zip && this.isCN) {
        f = this.CheckRegx(this.regx.shipzip, this.data.receiver_zip);
        if (!f) return this.CheckRegxZip();
      }
      const info = this.data;
      const self = this;
      self.isShowFromLoading = true;
      const param = {
        "id": self.componentData.ID,
        "provinceId": info.cp_c_region_province_id,
        "cityId": info.cp_c_region_city_id,
        "areaId": info.cp_c_region_area_id,
        "townName": info.cp_c_region_town_ename,
        "address": info.receiver_address,
        "receiverName": info.receiver_name,
        "receiverMobile": info.receiver_mobile,
        "receiverPhone": info.receiver_phone,
        "receiverZip": info.receiver_zip,
        "range": info.updateScope
      };
      // this.service.orderCenter.saveOrder(param).then((res) => {
      this.service.common.publicUrlParams('/api/cs/oc/oms/v1/address/modify', param).then((res) => {
        self.isShowFromLoading = false;
        self.isWatchChange = false;
        if (res.data.code === 0) {
          if (res.data.message) this.$Message.success(res.data.message);
          if (
            self.componentData.CALLBACK
            & (typeof self.componentData.CALLBACK === 'function')
          ) {
            self.componentData.CALLBACK();
          } else {
            try {
              self.$parent.$parent.$parent.autoRefresh();
            } catch (e) {}
          }
          self.$parent.$parent.closeConfirm();
        } else if (res.data.code === 1) {
          $fcWarn({
            title: t('提示'),
            content: res.data.data,
          });
          if (self.componentData.CALLBACK & (typeof self.componentData.CALLBACK === 'function')) {
            self.componentData.CALLBACK();
          } else {
            try {
              self.$parent.$parent.$parent.autoRefresh();
            } catch (e) {}
          }
          self.$parent.$parent.closeConfirm();
        } else {
          $fcError(res.data.message);
        }
      });
    },
    /** 校验规则
     * s 字符串
     * reg  正则表达式
     */
    CheckRegx(reg, s) {
      return reg.test(s);
    },
    // CheckRegxName() {
    //   $fcError("收货人姓名不能为空,不能包含数字或者字符");
    // },
    CheckRegxMobile() {
      return $fcError(t('收货人手机不合法'));
    },
    CheckRegxPhone() {
      return $fcError(t('收货人电话不合法'));
    },
    CheckRegxZip() {
      return $fcError(t('邮编不合法'));
    },
    searchProv() {
      const name = this.ReceivProvinceName;
      const obj = this.provList.find(
        item => item.ENAME === name
          || item.ENAME === `${name}市`
          || item.ENAME === `${name}省`
      );
      if (obj) {
        this.ReceivProvince = obj.ID || '';
        // 查找城市
        return new Promise((resolve) => {
          this.getCity(resolve, this.ReceivProvince);
        });
      }
      $fcError(t('请正确填写省份'));
      this.dataAysis = false;
    },
    searchCity() {
      const name = this.ReceivCityName || '';
      const obj = this.cityList.find(
        item => item.ENAME === name || item.ENAME === `${name}市`
      );
      if (obj) {
        this.ReceivCity = obj.ID;
        // 查找城市
        return new Promise((resolve) => {
          this.getArea(resolve, this.ReceivCity);
        });
      }
      $fcError(t('请正确填写城市'));
      this.dataAysis = false;
    },
    searchArea() {
      const name = this.ReceivAreaName || '';
      const obj = this.areaList.find(
        item => item.ENAME === name || item.ENAME === `${name}区`
      );
      if (obj) {
        this.ReceivArea = obj.ID;
      } else {
        $fcError(t('请正确填写区县'));
        this.dataAysis = false;
      }
    },
    async getProv() {
      const query = {
        ID: null,
        REGIONTYPE: 'COUN',
      };
      const res = await this.service.common.regionBySelect(query);
      // this.clearCity();
      if (res.data ? res.data.code === 0 : false) {
        this.provList = res.data.data.data.map(row => ({
          ID: row.ID,
          ENAME: row.ENAME,
        }));
      } else {
        $fcError("省份查询失败");
      }
    },
    /** 回调
     *
     * callback
     * prov 省份
     */
    async getCity(callback, prov) {
      const provid = prov || this.data.cp_c_region_province_id;
      if(provid === null  || provid === void 0) return
      if (provid === '') return $fcError(t('请先选择省份'));
      const query = {
        ID: provid,
        REGIONTYPE: 'PROV',
      };
      const res = await this.service.common.regionBySelect(query);
      if (res.data ? res.data.code === 0 : false) {
        this.cityList = res.data.data.data.map((row) => ({
          ID: row.ID,
          ENAME: row.ENAME,
        }));
        if (this.areaList[0] && this.cityList[0].ID) {
          if (String(this.areaList[0].ID).substring(0, 2) !== String(this.cityList[0].ID).substring(0, 2)) {
            this.clearArea();
          }
        }
        // this.data.cp_c_region_area_id = this.componentData.CP_C_REGION_AREA_ID;
      } else {
        $fcError(t('城市查询失败'));
      }
      typeof callback === 'function' ? callback() : '';
    },
    async getArea(callback, city) {
      const cityid = city || this.data.cp_c_region_city_id;
      if(cityid === null || cityid === void 0) return
      if (cityid === '') return $fcError(t('请先选择城市'));
      const query = {
        ID: cityid,
        REGIONTYPE: 'CITY',
      };
      const res = await this.service.common.regionBySelect(query);
      if (res.data ? res.data.code === 0 : false) {
        this.areaList = res.data.data.data.map((row) => ({
          ID: row.ID,
          ENAME: row.ENAME,
        }));
      } else {
        $fcError("区县查询失败");
      }
      typeof callback === 'function' ? callback() : '';
    },
    async getTown(callback, area) {
      return // 接口目前不支持四级地址

      const areaid = area || this.data.cp_c_region_area_id;
      if(areaid === null  || areaid === void 0) return
      // if (cityid === "") return $fcError("请先选择城市");
      if (areaid === '') return $fcError('请先选择区');
      const query = {
        ID: areaid,
        REGIONTYPE: 'DIST',
      };
      const res = await this.service.common.regionBySelect(query);
      if (res.data ? res.data.code === 0 : false) {
        this.townList = res.data.data.data.map((row) => ({
          ID: row.ID,
          ENAME: row.ENAME,
        }));
      } else {
        // $fcError("区县查询失败");
        $fcError('查询街道失败');
      }
      typeof callback === 'function' ? callback() : '';
    },
    clearProv(v) {
      if (this.parseAddressLoad === true) return;
      this.cityList = [];
      this.data.cp_c_region_city_id = '';
      this.ReceivCity = '';
      this.data.platform_city = '';
      this.clearCity();
      this.clearArea(true);
      this.getPlatformAddress(this.provList, 'platform_province', v);
    },
    clearCity(v) {
      if (this.parseAddressLoad === true) return;
      this.areaList = [];
      this.data.cp_c_region_area_id = '';
      this.ReceivArea = '';
      this.data.platform_area = '';
      this.clearArea(true);
      this.getPlatformAddress(this.cityList, 'platform_city', v);
    },
    clearArea(isWatchChange, v) {
      isWatchChange !== undefined && (this.isWatchChange = true)
      if (this.isWatchChange) {
        this.data.cp_c_region_town_ename = '';
        this.ReceivTown = '';
        this.data.platform_town = '';
      }
      this.townList = [];
      this.clearTown();
      this.getPlatformAddress(this.areaList, 'platform_area', v);
    },
    clearTown() {
      this.data.cp_c_region_town_ename = '';
      this.data.platform_town = ''; // 平台街道
      this.data.cp_c_region_town_id = '';
    },
    townBlur(e){
      this.data.platform_town = e.target.value;
      if(!e.target.value)  this.clearTown();
    },
    handlerTownChange(v) {

      if (!v) {
        this.clearTown();
        return;
      }

      const townItem = this.townList.find((item) => item.ID === v)

      this.data.cp_c_region_town_ename = townItem?.ENAME;
      this.data.platform_town  = this.data.cp_c_region_town_ename
    },
    /**
     * 给平台地址赋值
     * @param listArr -  新地址对应的下拉框数据
     * @param key -  平台地址对应的 省市区
     * @param ID -  新地址的ID值
     */
    getPlatformAddress(listArr, key, ID) {
      if (ID !== undefined) {
        const obj = listArr.filter(item => item.ID === ID);
        this.data[key] = obj[0].ENAME || ''; // 给平台地址赋值
      }
    },
    onKeyDown(e) {
      if (this.$refs.newReceivAddress && this.$refs.newReceivAddress.$refs.input === document.activeElement) {
        return;
      }
      if (e.keyCode == 27) {
        this.$parent.$parent.closeConfirm();
      }
      if (e.keyCode == 13) {
        this.update();
      }
    },
  },
  created() {
    // 获取所有省份的接口
    this.getProv();
    this.componentData = this.$store.state.customize.addressForOrderDetail
    this.objId = this.componentData.ID;
    this.initAddress(this.componentData);

    openLoop(AI_LOOP_LOCAL_STORE_KEY, { startCb: this.aiDisabledStart, endCb: this.aiDisabledEnd });
  },
};
